import React, { ReactNode } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export interface OcCardButtonBarProps {
  handleLeftButton?: () => void;
  leftButtonColor?:
  | "inherit"
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "info"
  | "warning";
  leftButtonText?: string;
  leftButtonDisabled?: boolean;
  leftButtonId?: string;
  handleRightButton?: () => void;
  rightButtonColor?:
  | "inherit"
  | "primary"
  | "secondary"
  | "success"
  | "error"
  | "info"
  | "warning";
  rightButtonText?: string;
  rightButtonVariant?: "text" | "outlined" | "contained";
  rightButtonDisabled?: boolean;
  rightButtonId?: string;
  handlePrimaryButton?: () => void;
  primaryButtonText?: string;
  primaryButtonDisabled?: boolean;
  primaryButtonId?: string;
  noLine?: boolean;
  paddingTop?: string;
  startIcon?: ReactNode;
}

export const OcCardButtonBar: React.FC<OcCardButtonBarProps> = ({
  handleLeftButton,
  leftButtonColor,
  leftButtonText,
  leftButtonDisabled,
  leftButtonId = "handleLeftButton",
  handleRightButton,
  rightButtonColor,
  rightButtonText,
  rightButtonVariant = "text",
  rightButtonDisabled,
  rightButtonId = "handleRightButton",
  handlePrimaryButton,
  primaryButtonText,
  primaryButtonDisabled,
  primaryButtonId = "primaryButtonText",
  noLine,
  paddingTop = "32px",
  startIcon,
}) => {
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  const primaryIcon = startIcon;

  return (
    <Box>
      <Box paddingTop={paddingTop} />
      {!noLine && <Box height="1px" bgcolor={theme.palette.gray40.main} />}
      <Box
        display="flex"
        flexDirection={isMobile ? "column-reverse" : "row"}
        justifyContent="space-between"
        alignItems="center"
        paddingTop="16px"
      >
        {leftButtonColor ? (
          <Button
            fullWidth={isMobile}
            id={leftButtonId}
            variant="text"
            color={leftButtonColor}
            disabled={leftButtonDisabled}
            onClick={handleLeftButton}
          >
            {leftButtonText}
          </Button>
        ) : (
          <Box />
        )}
        {isMobile && <Box height="16px" />}
        <Box
          display="flex"
          flexDirection={isMobile ? "column-reverse" : "row"}
          width={isMobile ? "100%" : "auto"}
          alignItems="center"
        >
          {rightButtonText && (
            <>
              <Button
                fullWidth={isMobile}
                id={rightButtonId}
                variant={rightButtonVariant}
                color={rightButtonColor}
                disabled={rightButtonDisabled}
                onClick={handleRightButton}
                disableElevation
              >
                {rightButtonText}
              </Button>
              {isMobile && primaryButtonText && <Box height="16px" />}
            </>
          )}
          {primaryButtonText && (
            <>
              <Box width="16px" />
              <Button
                id={primaryButtonId}
                variant="contained"
                color="primary"
                disableElevation
                disabled={primaryButtonDisabled}
                onClick={handlePrimaryButton}
                style={{ width: isMobile ? "100%" : "auto" }}
                startIcon={primaryIcon}
              >
                {primaryButtonText}
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
